import {CSSProperties, FC} from 'react';


export interface IIconFacebookProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconFacebook: FC<IIconFacebookProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M24 11.977C24 5.363 18.626 0 12 0S0 5.363 0 11.977c0 6.613 5.374 11.976 12 11.976l.21-.002v-9.324H9.634V11.63h2.578V9.422c0-2.56 1.565-3.952 3.853-3.952 1.095 0 2.037.081 2.311.118v2.674h-1.577c-1.245 0-1.486.59-1.486 1.457v1.91h2.976l-.388 2.998h-2.588v8.864C20.328 22.055 24 17.443 24 11.977Z" clipRule="evenodd" />
        </svg>
    );
};
